import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/services/auth/auth/auth.service';
import type { UserRole } from '@app/interfaces/auth/auth.interfaces';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const allowedRoles = route.data['roles'] as readonly UserRole[]; 

  return authService.hasRequiredRole(allowedRoles)
    ? true
    : router.createUrlTree([authService.redirectPath]);
};
